import axios from 'axios';

import { handleError } from './utils';

export enum Features {
    inAppEvents = 'inAppEvents',
    banners = 'banners',
    events = 'events',
}

export const getEnabledFeatures = async (
    basepath = '/api',
): Promise<string[]> => {
    try {
        const response = await axios.get(`${basepath}/features`);

        return response.data;
    } catch (e) {
        handleError("Couldn't fetch enabled features", e);

        return [];
    }
};
